import React from 'react';
import PropTypes from 'prop-types';
import { withLock, keyVault } from '@bingads-webui-react/popup-manager';
import { Callout } from '@bingads-webui-react/callout';

export const CalloutWithLock = ({ lockKey, ...props }) => {
  const CalloutWithLockInner = withLock(Callout, {
    lockKey,
    force: true,
  });

  return (<CalloutWithLockInner {...props} />);
};

CalloutWithLock.propTypes = {
  lockKey: PropTypes.string,
};

CalloutWithLock.defaultProps = {
  lockKey: keyVault.hoveringPopup,
};
